import React from "react";
import styles from "./CopyrightFooter.module.scss";
import { FacebookLogo, LinkedinLogo, InstagramLogo, TwitterLogo } from "../../../assets/icons";
import { useNavigate } from "react-router-dom";
import { ApplicationRoutes } from "../../../routes";

type Props = {};

const CopyrightFooter: React.FC<Props> = (props: Props) => {

	const navigate = useNavigate();

	function navigateToComingSoon() {
		navigate(`/${ApplicationRoutes.COMING_SOON}`);
	  }

	return (
		<div className={styles.bottom}>
			<div className={styles.copyright}>Copyright © 1996-2024 SolarMart.com™. All rights reserved.</div>
			<div className={styles.socials}>
				<div className={styles.social} onClick={navigateToComingSoon}>
					<FacebookLogo />
				</div>
				<div className={styles.social} onClick={navigateToComingSoon}>
					<LinkedinLogo />
				</div>
				<div className={styles.social} onClick={navigateToComingSoon}>
					<InstagramLogo />
				</div>
				<div className={styles.social} onClick={navigateToComingSoon}>
					<TwitterLogo />
				</div>
			</div>
		</div>
	);
};

export default CopyrightFooter;
